import { getVisualStateDataAttributes } from "../getVisualStateDataAttributes";
import { tryGetBoolean } from "../tryGetBoolean";
export function getCommonVisualStateDataAttributes(componentProps) {
  return getVisualStateDataAttributes({
    error: tryGetBoolean(componentProps['error']),
    warning: tryGetBoolean(componentProps['warning'])
  });
}